<template>
  <div class="content-cont">
    <p class="header-title">{{ titleAction }} Document</p>
    <div class="hint-modal">
      Are you sure you want to <b>"{{ titleAction }}"</b> this document?
    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button
        @click="showDetailsAgain(action)"
        class="submit-action-btn btn btn-primary"
        size="md"
      >
        Cancel
      </button>
      <button @click="onSubmit(action)" class="btn cancel-btn" type="button">
        {{ titleAction }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ConfirmVaccine",
  data() {
    return {
      document_Id: null,
      titleAction: null,
    };
  },
  props: ["action"],
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("users", [
      "getVaccineToggleLoading",
      "getVaccineDeleteLoading",
      "getModalState",
    ]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("confirmVaccineModal");
    },
    action(action) {
      console.log("actionnnnn", action);
    },
  },
  methods: {
    ...mapActions("users", ["userDocumentStatus", "resetLoading"]),
    onSubmit(status) {
      const { userDocumentStatus, document_Id } = this;
      userDocumentStatus({
        id: document_Id,
        status,
      }).then(() => {
        this.$emit("changeUserStatusOrDeleted", this.getModalInfo.data.id);
      });
    },
    showDetailsAgain() {
      this.$bvModal.hide("confirmVaccineModal");
      this.$bvModal.show("vaccineDetailsModal");
    },
  },
  beforeMount() {
    this.resetLoading();
  },
  mounted() {
    if (this.getModalInfo) {
      const {
        LastVaccine: { id },
      } = this.getModalInfo.data;
      this.document_Id = id;
      if (this.action == "DISABLED") {
        this.titleAction = "Disable";
      } else if (this.action == "ENABLED") {
        this.titleAction = "Enable";
      } else if (this.action == "DELETED") {
        this.titleAction = "Delete";
      }

      console.log("document_Id", this.document_Id);
      console.log("titleAction", this.titleAction);
    }
  },
};
</script>

<style lang="scss">
div#confirmVaccineModal {
  // background: #F3F3F3;
  padding-inline-end: 0px !important;
  border-radius: 26px;

  div#confirmVaccineModal___BV_modal_content_ {
    width: 580px;
    position: absolute;
    top: 200px;
    // inset-inline-start: 30px;
    border-radius: 26px;
  }
  .modal-content .modal-body {
    padding: 0px !important;
    // border-radius: 26px;
    p.header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin: 41px auto 36px 46px;
      color: #000000;
    }
    .hint-modal {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      margin: 0 70px 43px 70px;
      text-align: center;
      color: #787878;
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 488px;
      margin: 0px auto 20px auto;
    }
    .action-btns {
      margin-bottom: 20px;
      .submit-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 111px;
        height: 33px;
        color: #ffffff;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        margin-inline-end: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .cancel-btn {
        border: 1.5px solid #f46a6a;
        border-radius: 16.6275px;
        color: #f46a6a;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        width: 111px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
